(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["react-codes-input"] = factory(require("React"));
	else
		root["react-codes-input"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__24__) {
return 